import * as React from 'react';
import CardMedia from '@mui/material/CardMedia';

export default function VivaIcon() {
  return (
    <div style={{
      display: "flex", // Enable Flexbox
      alignItems: "center", // Align items vertically in the center
    }}>
      <CardMedia src={'/images/logo-icon-2.png'} component="img" alt="logo" sx={{ width: { xs: 22, lg: 32 }, cursor: 'pointer' }} />
      <CardMedia src={'/images/logo-name-2.png'} component="img" alt="logo" sx={{ width: { xs: 38, lg: 56 }, cursor: 'pointer' }} />
    </div>
  );
}
